/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    CodeAndLabel,
    CodeAndLabelFromJSON,
    CodeAndLabelFromJSONTyped,
    CodeAndLabelToJSON,
    CodeAndLabelWithIndent,
    CodeAndLabelWithIndentFromJSON,
    CodeAndLabelWithIndentFromJSONTyped,
    CodeAndLabelWithIndentToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface AncillaryDistributionFormConfiguration
 */
export interface AncillaryDistributionFormConfiguration {
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof AncillaryDistributionFormConfiguration
     */
    readonly ancillaries?: Array<GuidIdAndLabel> | null;
    /**
     * 
     * @type {Array<Int32IdAndLabel>}
     * @memberof AncillaryDistributionFormConfiguration
     */
    readonly ancillaryCategories?: Array<Int32IdAndLabel> | null;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof AncillaryDistributionFormConfiguration
     */
    readonly suppliers?: Array<GuidIdAndLabel> | null;
    /**
     * 
     * @type {Array<BrandAndMarketListItem>}
     * @memberof AncillaryDistributionFormConfiguration
     */
    readonly brandsAndMarkets?: Array<BrandAndMarketListItem> | null;
    /**
     * 
     * @type {Array<Int32IdAndLabel>}
     * @memberof AncillaryDistributionFormConfiguration
     */
    readonly distributionChannels?: Array<Int32IdAndLabel> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof AncillaryDistributionFormConfiguration
     */
    readonly relevances?: Array<number> | null;
    /**
     * 
     * @type {Array<CodeAndLabelWithIndent>}
     * @memberof AncillaryDistributionFormConfiguration
     */
    readonly regions?: Array<CodeAndLabelWithIndent> | null;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof AncillaryDistributionFormConfiguration
     */
    readonly agencyGroups?: Array<GuidIdAndLabel> | null;
    /**
     * 
     * @type {Array<CodeAndLabel>}
     * @memberof AncillaryDistributionFormConfiguration
     */
    readonly salesJourneys?: Array<CodeAndLabel> | null;
}

export function AncillaryDistributionFormConfigurationFromJSON(json: any): AncillaryDistributionFormConfiguration {
    return AncillaryDistributionFormConfigurationFromJSONTyped(json, false);
}

export function AncillaryDistributionFormConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): AncillaryDistributionFormConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ancillaries': !exists(json, 'ancillaries') ? undefined : (json['ancillaries'] === null ? null : (json['ancillaries'] as Array<any>).map(GuidIdAndLabelFromJSON)),
        'ancillaryCategories': !exists(json, 'ancillaryCategories') ? undefined : (json['ancillaryCategories'] === null ? null : (json['ancillaryCategories'] as Array<any>).map(Int32IdAndLabelFromJSON)),
        'suppliers': !exists(json, 'suppliers') ? undefined : (json['suppliers'] === null ? null : (json['suppliers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
        'brandsAndMarkets': !exists(json, 'brandsAndMarkets') ? undefined : (json['brandsAndMarkets'] === null ? null : (json['brandsAndMarkets'] as Array<any>).map(BrandAndMarketListItemFromJSON)),
        'distributionChannels': !exists(json, 'distributionChannels') ? undefined : (json['distributionChannels'] === null ? null : (json['distributionChannels'] as Array<any>).map(Int32IdAndLabelFromJSON)),
        'relevances': !exists(json, 'relevances') ? undefined : json['relevances'],
        'regions': !exists(json, 'regions') ? undefined : (json['regions'] === null ? null : (json['regions'] as Array<any>).map(CodeAndLabelWithIndentFromJSON)),
        'agencyGroups': !exists(json, 'agencyGroups') ? undefined : (json['agencyGroups'] === null ? null : (json['agencyGroups'] as Array<any>).map(GuidIdAndLabelFromJSON)),
        'salesJourneys': !exists(json, 'salesJourneys') ? undefined : (json['salesJourneys'] === null ? null : (json['salesJourneys'] as Array<any>).map(CodeAndLabelFromJSON)),
    };
}

export function AncillaryDistributionFormConfigurationToJSON(value?: AncillaryDistributionFormConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}


